'use client';

export {
  applyTheme,
  THEME_DEFAULT,
  ThemeSettingsModal,
  ThemeSettingsProvider,
  type ThemeState,
} from '@/platform/theme/ThemeSettings';
